export enum UserRole {
    client = 0,
    external,
    user,
    manager,
    admin,
    superadmin,
}



// WEBPACK FOOTER //
// ./client/app/core/auth/roles.enum.ts